import { useLoad } from "@redotech/react-util/load";
import { createContext } from "react";

export const CustomFieldContext = createContext<
  { name: string; options: { id: string; name: string }[] } | undefined
>(undefined);

export function CustomFieldProvider({
  children,
  customFieldId,
}: {
  children: React.ReactNode;
  customFieldId: string;
}) {
  const customFieldOptions = useLoad(async () => {
    // TODO: Get custom field options from db
    return { name: "Custom Field", options: [{ id: "1", name: "Option 1" }] };
  }, [customFieldId]);

  return (
    <CustomFieldContext.Provider
      value={
        customFieldOptions.value
          ? {
              name: customFieldOptions.value.name,
              options: customFieldOptions.value.options,
            }
          : undefined
      }
    >
      {children}
    </CustomFieldContext.Provider>
  );
}
